
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
// import { getDatabase } from "firebase/database";
// import { initializeApp } from "firebase-admin/app";
// const { initializeApp } = require("firebase-admin/app");
import { getAuth, GoogleAuthProvider, FacebookAuthProvider, signInWithPopup, fetchSignInMethodsForEmail, getAdditionalUserInfo, connectAuthEmulator } from 'firebase/auth';
import { setAuthenticated, clearloginAuthenticatedErrors, loginUserFailed} from './redux/UserAuthentication/LoginActions';
import store from "redux/store";
import axios from "axios";
import Swal from 'sweetalert2'


import {
    getFirestore,
    setDoc,
    getDocs,
    collection,
    query,
    where,
    onSnapshot,
    doc,
    orderBy,
    limit,
    connectFirestoreEmulator,
  } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyB3tv26UU1rcyjoL-0QRX_IuBhP4uYufm4",
    authDomain: "pmrprep.io",
    projectId: "pmr-bank",
    storageBucket: "pmr-bank.firebasestorage.app",
    messagingSenderId: "495610193299",
    appId: "1:495610193299:web:73d28e01d8b294974df466",
    measurementId: "G-VVHN0L1QSW"
};


// Initialize Firebase
export const app = initializeApp(firebaseConfig);
// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// export const db = getFirestore();
// connectFirestoreEmulator(db,"localhost", 8080)

export const storage = getStorage(app);
// export const rtdb = getDatabase(app);

export const auth = getAuth(app);

// export const auth = getAuth();
// connectAuthEmulator(auth, "http://127.0.0.1:9099")


const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();


const providerNameMap = {
    'google.com': 'Google',
    'facebook.com': 'Facebook',
    'password': 'Email and Password',
    'apple.com': 'Apple'
};

const defaultGrades = {
    cumulativeOther: 0,
    cumulativeScience: 0,
    cumulativeTotal: 0,
    freshmanOther: 0,
    freshmanScience:0,
    freshmanTotal:0,
    juniorOther:0,
    juniorScience:0,
    juniorTotal:0,
    seniorOther:0,
    seniorScience:0,
    seniorTotal:0,
    sophomoreOther:0,
    sophomoreScience:0,
    sophomoreTotal:0,
    postbacOther:0,
    postbacScience:0,
    postbacTotal:0,
    graduateOther:0,
    graduateScience:0,
    graduateTotal:0
}


export const signInWithGoogle = async () => {
    try {
        const result = await signInWithPopup(auth, googleProvider);
        const token = await result.user.getIdToken();
        const refreshToken = result.user.refreshToken;


        localStorage.setItem('FBIdToken', `Bearer ${token}`)
        localStorage.setItem('FBRefreshToken', refreshToken)

        const userCollection = collection(db,"users")
       

        const getUserDetails = query(
            userCollection,
            where("email", "==", result.user.email.toLowerCase())
        )

        const querySnapshot = await getDocs(getUserDetails);

        querySnapshot.forEach((doc) => {
            store.dispatch(setAuthenticated(doc.data()));
            axios.defaults.headers.common['Authorization'] = token

            store.dispatch(clearloginAuthenticatedErrors());
        });


        // return { user: result.user, token };

    } catch (error) {
        if (error.code === "auth/account-exists-with-different-credential") {
            const email = error.customData?.email;
            const methods = await fetchSignInMethodsForEmail(auth, email);
            const preferred = providerNameMap[methods[0]] || methods[0];
      
    
    
            store.dispatch(loginUserFailed({response:{data:{general:`This email is already registered with ${preferred}. Please log in using your ${preferred} account.`}}}));
        }
    }

};
  


export const signInWithFacebook = async () => {
    try {
      const result = await signInWithPopup(auth, facebookProvider);
      const token = await result.user.getIdToken();
      const refreshToken = result.user.refreshToken;
  
      localStorage.setItem('FBIdToken', `Bearer ${token}`);
      localStorage.setItem('FBRefreshToken', refreshToken);
  
      const userCollection = collection(db, "users");
      const getUserDetails = query(
        userCollection,
        where("email", "==", result.user.email)
      );
  
      const querySnapshot = await getDocs(getUserDetails);
  
      querySnapshot.forEach((doc) => {
        store.dispatch(setAuthenticated(doc.data()));
        axios.defaults.headers.common['Authorization'] = token;
        store.dispatch(clearloginAuthenticatedErrors());
      });

    } catch (error) {
      if (error.code === "auth/account-exists-with-different-credential") {
        const email = error.customData?.email;
        const methods = await fetchSignInMethodsForEmail(auth, email);
        const preferred = providerNameMap[methods[0]] || methods[0];



        store.dispatch(loginUserFailed({response:{data:{general:`This email is already registered with ${preferred}. Please log in using your ${preferred} account.`}}}));
      }
    //   else{
    //     store.dispatch(loginUserFailed({response:{data:{general:"Something went wrong, Please try again!"}}}));
    //   }


    }
  };


export const signUpWithGoogle = async () => {
    try {
        const result = await signInWithPopup(auth, googleProvider);

        Swal.fire({
            title: 'Loading...',
            text: 'Please wait',
            allowOutsideClick: false,
            didOpen: () => {
            Swal.showLoading();
            },
            timer: 5000, // Set duration to 3 seconds
            // timerProgressBar: true, // Optional: shows a progress bar
        });

        const token = await result.user.getIdToken();
        const refreshToken = result.user.refreshToken;
        
        localStorage.setItem('FBIdToken', `Bearer ${token}`);
        localStorage.setItem('FBRefreshToken', refreshToken);
    
        // Detect if user is new
        const additionalInfo = getAdditionalUserInfo(result);
        const isNewUser = additionalInfo?.isNewUser;
        
        if (isNewUser) {
            // Create Firestore doc for new user
            
            
            

            const userRef = doc(db, "users/" + result.user.email);
            await setDoc(userRef, {
                uid: result.user.uid,
                name: result.user.displayName.split(" (")[0],
                firstName: result.user.displayName.split(" (")[0],
                lastName: "",
                university: "",
                handle: result.user.email,
                email: result.user.email,
                userId: result.user.uid,
                tpcEntryDate: new Date().toISOString().split('T')[0],
                mcatDate: "",
                shadowGoal: 0,
                clinicalGoal: 0,
                volunteerGoal: 0,
                tutorHours: 0,
                subscriptions: [],
                ultimateAdvisingStudent: false,
                admin: false,
                phoneNumber: "",
                plan: "free account",
                proMemberStudent: false,
                createdAt: new Date().toISOString(),

            });

            

        
        
            await setDoc(doc(db, "grades/" + result.user.email), defaultGrades)
            // let data = new FormData();
            // data.append("name", result.user.displayName);
            // data.append("email", result.user.email);
            // data.append("phoneNumber", "");
            // data.append("tags", "tpc-tracker-signup");

            // let config = {
            //     method: "post",
            //     maxBodyLength: Infinity,
            //     url: "https://hooks.zapier.com/hooks/catch/6968877/35vr2u1/",
            //     headers: {
            //     ...data.getHeaders(),
            //     },
            //     data: data,
            // };

            // axios
            //     .request(config)
            //     .then((response) => {
            //     console.log(JSON.stringify(response.data));
            //     })
            //     .catch((error) => {
            //     console.log(error);
            //     });
        

        }
      
  
        // Proceed to fetch user from Firestore
        const userCollection = collection(db, "users");
        const getUserDetails = query(
            userCollection,
            where("email", "==", result.user.email.toLowerCase())
        );
        const querySnapshot = await getDocs(getUserDetails);
    
        querySnapshot.forEach((doc) => {
            
            store.dispatch(setAuthenticated(doc.data()));
            axios.defaults.headers.common['Authorization'] = token;
            store.dispatch(clearloginAuthenticatedErrors());
        });

    } catch (error) {

        if (error.code === "auth/account-exists-with-different-credential") {
            const email = error.customData?.email;
            const methods = await fetchSignInMethodsForEmail(auth, email);
            const preferred = providerNameMap[methods[0]] || methods[0];

            Swal.fire({
                title:'Failed!',
                text:`This email is already registered with ${preferred}. Please log in using your ${preferred} account.`,
                icon :'error',
                timer: 3000

            })


        }
        // else{

        //     Swal.fire({
        //         title:'Failed!',
        //         text: "Something went wrong, Please try again!",
        //         icon :'error',
        //         timer: 3000

        //     })
        // }
    }
};

export const signUpWithFacebook = async () => {
    try {
        const result = await signInWithPopup(auth, facebookProvider);

        Swal.fire({
            title: 'Loading...',
            text: 'Please wait',
            allowOutsideClick: false,
            didOpen: () => {
            Swal.showLoading();
            },
            timer: 5000, // Set duration to 3 seconds
            // timerProgressBar: true, // Optional: shows a progress bar
        });

        const token = await result.user.getIdToken();
        const refreshToken = result.user.refreshToken;
        
        localStorage.setItem('FBIdToken', `Bearer ${token}`);
        localStorage.setItem('FBRefreshToken', refreshToken);
    
        // Detect if user is new
        const additionalInfo = getAdditionalUserInfo(result);
        const isNewUser = additionalInfo?.isNewUser;
        
        if (isNewUser) {
            // Create Firestore doc for new user
            
            const userRef = doc(db, "users/" + result.user.email);
            await setDoc(userRef, {
                uid: result.user.uid,
                name: result.user.displayName.split(" (")[0],
                university: "",
                handle: result.user.email,
                email: result.user.email,
                userId: result.user.uid,
                tpcEntryDate: new Date().toISOString().split('T')[0],
                mcatDate: "",
                shadowGoal: 0,
                clinicalGoal: 0,
                volunteerGoal: 0,
                tutorHours: 0,
                subscriptions: [],
                ultimateAdvisingStudent: false,
                admin: false,
                phoneNumber: "",
                plan: "free account",
                proMemberStudent: false,
                createdAt: new Date().toISOString(),

            });

        
        
            await setDoc(doc(db, "grades/" + result.user.email), defaultGrades)
            // let data = new FormData();
            // data.append("name", result.user.displayName);
            // data.append("email", result.user.email);
            // data.append("phoneNumber", "");
            // data.append("tags", "tpc-tracker-signup");

            // let config = {
            //     method: "post",
            //     maxBodyLength: Infinity,
            //     url: "https://hooks.zapier.com/hooks/catch/6968877/35vr2u1/",
            //     headers: {
            //     ...data.getHeaders(),
            //     },
            //     data: data,
            // };

            // axios
            //     .request(config)
            //     .then((response) => {
            //     console.log(JSON.stringify(response.data));
            //     })
            //     .catch((error) => {
            //     console.log(error);
            //     });
        

        }
      
  
        // Proceed to fetch user from Firestore
        const userCollection = collection(db, "users");
        const getUserDetails = query(
            userCollection,
            where("email", "==", result.user.email)
        );
        const querySnapshot = await getDocs(getUserDetails);
    
        querySnapshot.forEach((doc) => {
            store.dispatch(setAuthenticated(doc.data()));
            axios.defaults.headers.common['Authorization'] = token;
            store.dispatch(clearloginAuthenticatedErrors());
        });

    } catch (error) {

        if (error.code === "auth/account-exists-with-different-credential") {
            const email = error.customData?.email;
            const methods = await fetchSignInMethodsForEmail(auth, email);
            const preferred = providerNameMap[methods[0]] || methods[0];

            Swal.fire({
                title:'Failed!',
                text:`This email is already registered with ${preferred}. Please log in using your ${preferred} account.`,
                icon :'error',
                timer: 3000

            })


        }
        // else{

        //     Swal.fire({
        //         title:'Failed!',
        //         text: "Something went wrong, Please try again!",
        //         icon :'error',
        //         timer: 3000

        //     })
        // }
    }
};


export const getGoogleEmailAddress = async () => {
    try {
        const result = await signInWithPopup(auth, googleProvider);

        Swal.fire({
            title: 'Loading...',
            text: 'Please wait',
            allowOutsideClick: false,
            didOpen: () => {
            Swal.showLoading();
            },
            timer: 5000, // Set duration to 3 seconds
            // timerProgressBar: true, // Optional: shows a progress bar
        });

        return result.user.email

    
    } catch (error) {

        if (error.code === "auth/account-exists-with-different-credential") {
            const email = error.customData?.email;
            const methods = await fetchSignInMethodsForEmail(auth, email);
            const preferred = providerNameMap[methods[0]] || methods[0];

            Swal.fire({
                title:'Failed!',
                text:`This email is already registered with ${preferred}. Please log in using your ${preferred} account.`,
                icon :'error',
                timer: 3000
                
            })


        }

        return ""
    }

}